import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { createBrowserHistory } from "history";
import { NCallContextProvider } from "./context/ncall-context";
import "react-toastify/dist/ReactToastify.css";
import NCallSchedular from "./components/calendar/schedular";
import MakeReport from "./components/reports/makeReport";

import * as Pages from "./pages";
import Loader from "./components/loader";
import EditReport from "./components/reports/editReport";
import ViewReport from "./components/reports/viewReport";

function PrivateRoute({ children }) {
  const loggedInAs = localStorage.getItem("logged-in-as") || null;

  if (!loggedInAs) return <Navigate to="/" />;

  return children;
}

function App() {
  const history = createBrowserHistory();

  function handlePopstate(event) {
    history.go(1);
  }

  window.addEventListener("popstate", handlePopstate);

  useEffect(() => {
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  return (
    <NCallContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/client-login" element={<Pages.LoginClient />} />
          <Route
            path="/client/*"
            element={
              <PrivateRoute>
                <Pages.Client />
              </PrivateRoute>
            }
          >
            <Route path="" element={<Pages.ClientCalendar />} />
            <Route path="schedules" element={<Pages.ClientSchedules />} />
            <Route exact path="view-report" element={<ViewReport />} />
            <Route path="*" element={<Navigate to="" />} />
          </Route>
          {/* <Route path="/client/*" element={<Navigate to="/client" />} /> */}
          <Route path="/admin-login" element={<Pages.LoginAdmin />} />
          <Route
            path="/admin/*"
            element={
              <PrivateRoute>
                <Pages.Admin />
              </PrivateRoute>
            }
          >
            <Route path="" element={<Pages.Clients />} />
            <Route path="colors" element={<Pages.StatusColorLinkup />} />
            <Route path="client-detail/*" element={<Pages.Detail />}>
              <Route exact path="" element={<NCallSchedular />} />
              <Route exact path="schedules" element={<Pages.Schedules />} />
              <Route exact path="employees" element={<Pages.Employees />} />
              <Route exact path="shifts" element={<Pages.Shifts />} />
              <Route exact path="departments" element={<Pages.Departments />} />
              <Route exact path="reports" element={<Pages.Reports />} />
              <Route exact path="reports/new-report" element={<MakeReport />} />
              <Route
                exact
                path="reports/edit-report"
                element={<EditReport />}
              />
              <Route
                exact
                path="reports/view-report"
                element={<ViewReport />}
              />
              {/* wild card route for client-detail */}
              <Route path="*" element={<Navigate to="" />} />
            </Route>
            {/* wild card route for admin */}
            <Route path="*" element={<Navigate to="" />} />
          </Route>

          <Route path="/" element={<Pages.Home />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </NCallContextProvider>
  );
}

export default App;

// url : https://scheduler.answertbay.com/admin/client-detail
